import request from '@/utils/request'

export function login(data) { //登录
    return request({
        method: 'post',
        url: 'login',
        params: data
    })
}

export function getImageCode(data) { //验证码
    return request({
        method: 'get',
        url: '/image/getCode',
        params: data
    })
}

export function tbSysAddUserInfo(data) { //登录成功记录用户信息
    return request({
        method: 'post',
        url: '/tbSysUser/addUserInfo',
        data
    })
}

export function tbSysRoleQuery(data) { //角色管理 - 查询
    return request({
        method: 'get',
        url: '/tbSysRole/query',
        params: data
    })
}

export function tbSysRoleAdd(data) { //角色管理 - 新增
    return request({
        method: 'post',
        url: '/tbSysRole/add',
        data
    })
}

export function tbSysRoleUpdate(data) { //角色管理 - 编辑
    return request({
        method: 'post',
        url: '/tbSysRole/update',
        data
    })
}

export function tbSysRoleMenuAddBatch(data) { //角色管理 - 配置菜单权限
    return request({
        method: 'post',
        url: 'tbSysRoleMenu/addBatch',
        data
    })
}

export function tbSysRoleDelete(data) { //角色管理 - 删除
    return request({
        method: 'post',
        url: 'tbSysRole/delete',
        data
    })
}

export function tbSysBlackQuery(data) { //黑名单 - 查询
    return request({
        method: 'get',
        url: 'tbSysBlack/query',
        params: data
    })
}

export function tbSysBlackUpdate(data) { //黑名单 - 编辑
    return request({
        method: 'post',
        url: '/tbSysBlack/update',
        data
    })
}

export function tbSysBlackDelete(data) { //黑名单 - 删除
    return request({
        method: 'post',
        url: 'tbSysBlack/delete',
        data
    })
}

export function tbSysLogQuery(data) { //日志 - 查询
    return request({
        method: 'get',
        url: 'tbSysLog/query',
        params: data
    })
}


export function tbSysAttachmentQuery(data) { // 附件查询
    return request({
        method: 'get',
        url: 'tbSysAttachment/query',
        params: data
    })
}


export function tbSysAttachmentUploadFile(data) { //附件 上传 1
    return request({
        method: 'post',
        url: '/tbSysAttachment/uploadFile',
        data
    })
}
export function tbSysAttachmentUpdate(data) { //附件 更新附件信息 2
    return request({
        method: 'post',
        url: '/tbSysAttachment/update',
        data
    })
}

export function tbSysAttachmentDelete(data) { //附件 删除附件
    return request({
        method: 'post',
        url: '/tbSysAttachment/delete',
        data
    })
}


export function tbSysAttachmentGetFilePath(data) { //附件 预览
    return request({
        method: 'get',
        url: '/tbSysAttachment/getFilePath/'+data,
        
    })
}


export function tbSysAttachmentDownload(data) { //附件 下载
    return request({
        method: 'get',
        url: '/tbSysAttachment/download/'+data,
        responseType: "blob",
        headers: {   'Content-Type': 'application/json'  },
        withCredentials: true,    
        
    })
}
export function tbSysDictDefinitionQueryEnumList(data) { //获取课程类型
    return request({
        method: 'get',
        url: '/tbSysDictDefinition/queryEnumList',
        data: {code: "TB_WF_ITEM__TYPE"},
        params: {code: "TB_WF_ITEM__TYPE"}
    })
}

export function tbWfRecordQuery(data) { // 专家意见
    return request({
        method: 'get',
        url: 'tbWfRecord/query',
        params: data
    })
}


export function tbWfItemQueryHomeDone(data) { //课程 审批时 --- 审核人信息
    return request({
        method: 'get',
        url: '/tbWfItem/queryHomeDone/',
        params: data
    })
}

export function tbSysDictDefinitionImageType(data) { // 上传图片类型获取
    return request({
        method: 'get',
        url: '/tbSysDictDefinition/queryConstantStrList',
        params: data
    })
}


